import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import S from './Odometer.module.scss';

export interface OdometerProps {
  value: number;
  onAnimationComplete: () => void;
}

const Odometer: FC<OdometerProps> = ({ value = 0, onAnimationComplete }) => {
  const paddedValue = Math.ceil(value).toString().padStart(3, '0');

  return (
    <>
      <AnimatePresence>
        {value !== 100 && (
          <motion.div
            style={{ visibility: 'hidden' }}
            exit={{ opacity: 0 }}
            onAnimationComplete={onAnimationComplete}
          />
        )}
      </AnimatePresence>
      <div className={S.Odometer}>
        <div
          className={S.Digit}
          style={{
            visibility: paddedValue[0] === '0' ? 'hidden' : 'visible',
          }}
        >
          {paddedValue[0]}
        </div>
        <div className={S.Digit}>{paddedValue[1]}</div>
        <div className={S.Digit}>{paddedValue[2]}</div>
      </div>
    </>
  );
};

export default Odometer;
